module.exports = __webpack_public_path__ + "img/63_4.aced336f.png";